import { render, staticRenderFns } from "./ServicePortalDocumentation.vue?vue&type=template&id=cf9dd41a&"
import script from "./ServicePortalDocumentation.vue?vue&type=script&lang=js&"
export * from "./ServicePortalDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./ServicePortalDocumentation.vue?vue&type=style&index=0&id=cf9dd41a&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf9dd41a')) {
      api.createRecord('cf9dd41a', component.options)
    } else {
      api.reload('cf9dd41a', component.options)
    }
    module.hot.accept("./ServicePortalDocumentation.vue?vue&type=template&id=cf9dd41a&", function () {
      api.rerender('cf9dd41a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ServicePortalDocumentation.vue"
export default component.exports